<template>
    <div>
        <h1>Certifikaty</h1>
        <p>Manage your account details here.</p>
        <p>User Name: {{ user.full_name }}</p>
        <p>Email: {{ user.email }}</p>
        <!-- Additional settings form -->
    </div>
</template>

<script>
export default {
    props: {
        user: {
            type: Object,
            required: true
        }
    }
}
</script>